module.exports = __webpack_public_path__ + "static/Deceit-730f5e1c9af46a8a3df349fe7a0daf29.png";